module.exports = __webpack_public_path__ + "img/hyperx-quadcast-preview.d152b0d0.png";